import { msg } from '@lingui/core/macro';
import { ROUTES } from '@router/constants.ts';
import { translateItem } from '@utils/translations.ts';

export const START_PAGE_VALUES = {
    LEARNING: ROUTES.SIDEBAR.LEARNING,
    ADMIN: `${ROUTES.SIDEBAR.ADMIN.ROOT}/${ROUTES.SIDEBAR.ADMIN.TENANT_CLIENT_ADMINISTRATION}`,
    FLEET_DASHBOARD: `${ROUTES.SIDEBAR.ADMIN.ROOT}/${ROUTES.SIDEBAR.ADMIN.FLEET_DASHBOARD}`,
    VESSEL_DASHBOARD: `${ROUTES.SIDEBAR.ADMIN.ROOT}/${ROUTES.SIDEBAR.ADMIN.VESSEL_DASHBOARD}`,
} as const;

export const START_PAGES_OPTIONS = [
    { label: msg`My Learning`, value: START_PAGE_VALUES.LEARNING },
    { label: msg`Admin`, value: START_PAGE_VALUES.ADMIN },
    { label: msg`Fleet Dashboard`, value: START_PAGE_VALUES.FLEET_DASHBOARD },
    { label: msg`Vessel Dashboard`, value: START_PAGE_VALUES.VESSEL_DASHBOARD },
];

export const getStartPagesOptions = () =>
    START_PAGES_OPTIONS.map(({ label, value }) => ({
        label: translateItem(label),
        value,
    }));

export const TIME_FORMAT_OPTIONS = [
    { value: '24h', label: msg`24-Hours (eg. 17:00)` },
    { value: '12h', label: msg`12-Hours (eg. 05:00 PM)` },
];

export const getTimeFormatOptions = () =>
    TIME_FORMAT_OPTIONS.map(({ label, value }) => ({
        label: translateItem(label),
        value,
    }));

export const SHARED_USER_PREFERENCES_TAB_SAVE = msg`Save`;
export const SHARED_USER_PREFERENCES_TAB_UNDO = msg`Undo`;
export const SHARED_USER_PREFERENCES_TAB_HEADER = msg`User Preferences`;
export const SHARED_USER_PREFERENCES_TAB_INFO = msg`Set your interface preferences`;
export const SHARED_USER_PREFERENCES_TAB_START_PAGE_LABEL = msg`Preferred start page`;
export const SHARED_USER_PREFERENCES_TAB_DATE_FORMAT_LABEL = msg`Preferred date format`;
export const SHARED_USER_PREFERENCES_TAB_TIME_FORMAT_LABEL = msg`Preferred time format`;
export const SHARED_USER_PREFERENCES_TAB_TOAST_DESCRIPTION = msg`User preferences have been changed.`;
